import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import { Button } from 'core/components/button';
import FormList from 'core/components/form-list';
import Individual from './individual';
import AddPerson from './add-form';
import useStyles from './non-rated-individuals.styles';

const NonRatedIndividuals = ({ disabled, openByDefault = false }) => {
  const classes = useStyles();

  const { values } = useFormikContext();

  const hasNonRatedIndividualsWithoutReason = values.removedDrivers?.some((driver) => !driver.removedReason);

  const [open, setOpen] = useState(openByDefault);

  useEffect(() => {
    if (!open && hasNonRatedIndividualsWithoutReason) {
      setOpen(true);
    }
  }, [hasNonRatedIndividualsWithoutReason]);

  const IndividualPersonForm = (props) => <Individual {...props} initialOpen={hasNonRatedIndividualsWithoutReason} />;

  if (!open) {
    return (
      <Button onClick={() => setOpen(true)} className={classes.showHideButton} color="secondary">
        {values.removedDrivers?.length > 0
          ? `Show ${values.removedDrivers.length} non-rated individual(s)`
          : 'Add a non-rated individual'}
      </Button>
    );
  }

  return (
    <div className={classes.container} id="nonRatedIndividuals">
      <FormList
        disabled={disabled}
        id="removedDrivers"
        item={IndividualPersonForm}
        addForm={AddPerson}
        addLabel="Add Non-rated Individual"
        title="Non-rated Individuals"
        singular="individual"
        plural="individuals"
        sectionTooltip="Non-rated individuals are people who live or have lived in the household who aren’t required to be listed as drivers on the auto policy. Including all non-rated individuals who are not drivers on the policy helps avoid potential claim denials in case an accident involving them."
      />
    </div>
  );
};

export default NonRatedIndividuals;

NonRatedIndividuals.propTypes = {
  disabled: PropTypes.bool
};

NonRatedIndividuals.defaultProps = {
  disabled: false
};
